import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const LegendItem = ({ color, label }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <StarIcon sx={{ color, fontSize: '1rem' }} />
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

const RatingLegend = () => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', ml: 2 }}>
      <LegendItem color="gold" label="Your Rating" />
      <LegendItem color="#81c784" label="Kritic Rating" />
    </Box>
  );
};

export default RatingLegend;
